import ClueDetailNewPage from "@/pages/clueManage/clueDetail";
import {useParams, useSearchParams} from "react-router-dom";

const ClueDetailSale = () => {
  const {id} = useParams()
  const [search] = useSearchParams()
  const saleClueId = search.get('saleClueId')
  return <ClueDetailNewPage id={id} saleClueId={saleClueId} viewPhoneKey={'salePlanViewPhone'}/>
}

export default ClueDetailSale